<template>
<div>
    <nav-bar></nav-bar>
    <div id="loader"></div>
    <b-form-select @change="minuteChange" v-model="minuteSelected" :options="minuteOptions" class="mb-3" />
    <canvas id="myChart" width="400" height="200"></canvas>
</div>
</template>

<script>
import NavBar from '../components/NavBar'
import SessionData from '../components/SessionData'
const axios = require('axios')
export default {
  components: {
    NavBar,
    SessionData
  },
  data () {
    return {
      chartLables: [],
      chartData: [],
      minuteOptions: [
        { value: null, text: 'Change chart sample size' },
        { value: '1', text: '1 Minute samples' },
        { value: '2', text: '2 Minute samples' },
        { value: '3', text: '3 Minute samples' },
        { value: '5', text: '5 Minute samples' },
        { value: '10', text: '10 Minute samples' },
        { value: '20', text: '20 Minute samples' },
        { value: '30', text: '30 Minute samples' },
        { value: '60', text: '60 Minute samples' }],
      minuteSelected: null,
      solarBatteryChart: undefined,
      solarBatteryChartSampleSize: 5,
      graphRefreshTimer: undefined,
      lableUpdateInterval: undefined

    }
  },
  methods: {
    minuteChange (aChange) {
      console.log('minuteChange: ', aChange)
      let sessionChartData = this.$store.getters.solarGraphData
      if (sessionChartData !== undefined) {
        sessionChartData.sampleSize = parseInt(aChange)
        this.$store.commit('updateSolarGraphData', sessionChartData)
      }

      this.updateChart(aChange)
    },
    async updateChart (sampleSize) {
      const config = {
        method: 'get',
        url: 'https://shaneblaser.com/api/batteryData/' + sampleSize,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        }
      }
      try {
        document.getElementById('loader').style.display = 'block'
        let batteryData = await axios(config)
        if (batteryData === undefined) {
          console.log('batteryData came back undefined: ' + new Date())
        }
        this.chartLables = batteryData.data.date
        this.chartData = batteryData.data.voltage
        let chartData = {}
        chartData.data = batteryData.data.voltage
        chartData.lables = batteryData.data.date
        chartData.date = new Date()
        chartData.sampleSize = sampleSize
        this.$store.commit('updateSolarGraphData', chartData)
        await this.buildChart(batteryData.data.voltage, batteryData.data.date, chartData.sampleSize, chartData.date)
        // console.log(batteryData)
      } catch (error) {
        console.log('getBatteryData error: ', error)
      } finally {
        document.getElementById('loader').style.display = 'none'
      }
    },
    async buildChart (someChartData, someChartLables, sampleSize, chartDate) {
      if (this.solarBatteryChart !== undefined) {
        this.solarBatteryChart.destroy()
      }
      var chartAge = (new Date() - chartDate) / 1000 + ' seconds ago'
      // console.log('Chart date: ', chartAge)
      var ctx = document.getElementById('myChart')
      // eslint-disable-next-line
        this.solarBatteryChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: someChartLables,
          datasets: [{
            label: 'Battery Voltage ' + sampleSize + 'm average updated: ' + chartAge,
            data: someChartData,
            backgroundColor: '#e6ccff',
            borderColor: '#8e5ea2',
            fill: false,
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: false
              }
            }],
            xAxes: [{
              type: 'time',
              time: {
                displayFormats: {
                  quarter: 'MMM YYYY'
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                // console.log(tooltipItem)
                return tooltipItem.yLabel + 'v'
              },
              title: function (tooltipItem) {
                var aDate = new Date(tooltipItem[0].xLabel)
                return aDate.toLocaleString()
              }
            }
          }
        }
      })
      // this.solarBatteryChart.data.labels.splice(0, 0, 'new label')
      var me = this
      me.sampleSize = sampleSize
      me.chartDate = chartDate
      if (this.lableUpdateInterval === undefined) {
        console.log('creating interval ')
        this.lableUpdateInterval = setInterval(() => {
          let chartAge = (new Date() - me.chartDate) / 1000
          if (chartAge > 90) {
            chartAge = chartAge / 60
            chartAge = parseFloat(chartAge).toFixed(1)
            chartAge += ' minutes ago'
          } else {
            chartAge = parseFloat(chartAge).toFixed(0)
            if (chartAge < 1) { chartAge = 0 }
            chartAge += ' seconds ago'
          }
          let newLable = 'Battery Voltage ' + me.sampleSize + 'm average updated: ' + chartAge
          me.solarBatteryChart.config.data.datasets[0].label = newLable
          me.solarBatteryChart.update()
        }, 5000)
      }
    }
  },
  async mounted () {
    let sessionChartData = this.$store.getters.solarGraphData
    // console.log('sessionChartData: ', sessionChartData)
    if (sessionChartData !== undefined) {
      this.buildChart(sessionChartData.data, sessionChartData.lables, sessionChartData.sampleSize, sessionChartData.date)
      document.getElementById('loader').style.display = 'none'
    } else {
      this.updateChart(5)
    }
    if (this.graphRefreshTimer !== undefined) { clearInterval(this.graphRefreshTimer) }
    let anInterval = setInterval(() => {
      this.updateChart(this.$store.getters.solarGraphData.sampleSize)
    }, 120000)
    this.$store.commit('updateSolarSetInverval', anInterval)
  }
}

</script>
<style>
/* Center the loader */
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #6600cc;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@-webkit-keyframes animatebottom {
  from { bottom:-100px; opacity:0 }
  to { bottom:0px; opacity:1 }
}

@keyframes animatebottom {
  from{ bottom:-100px; opacity:0 }
  to{ bottom:0; opacity:1 }
}

#myDiv {
  display: none;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/SolarGraph.vue